import { useEffect, useState } from "react";
import FormHeader from "./components/FormHeader";
import DialogBox from "./components/DialogBox";
import { getUser } from "../../config/LiveApi";
import { useSelector } from "react-redux";

function index() {
  const token = useSelector((store) => store.userReducer.token);

  const [typeError, setTypeError] = useState(null);
  const [excelFile, setExcelFile] = useState(null);
  const [excelData, setExcelData] = useState(null);
  const [openData, setOpenData] = useState(false);
  const [listofusers, setListofUser] = useState(null);
  const [totalPages, setTotalPages] = useState(null);

  useEffect(() => {
    setOpenData(true);
  }, [excelData]);

  const fetchUsers = async (page) => {
    try {
      const response = await getUser(token);
      const data = response?.data;
      const paginationData = response?.meta;

      const adminUsers = data.filter((user) => user.role === "admin");

      setListofUser(adminUsers);
      setTotalPages(paginationData?.pagination?.page);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <div>
      <FormHeader
        setTypeError={setTypeError}
        setExcelFile={setExcelFile}
        setExcelData={setExcelData}
        listofusers={listofusers}
        totalPages={totalPages}
      />

      {openData && excelData && (
        <DialogBox setOpenData={setOpenData} excelData={excelData} />
      )}
    </div>
  );
}


export default index;
